export default {
    sX: 0,
	sY: 228,
	w: 173,
	h: 152,
	x: function (game) {
        return game.canvas.sack.width / 2 - this.w / 2
    },
	y: 80,

	draw: function (game) {
		if (game.state.current == game.state.getReady) {
			game.ctx.sack.drawImage(
				game.sprite,
				this.sX,
				this.sY,
				this.w,
				this.h,
				this.x(game),
				this.y,
				this.w,
				this.h
			);
		}
	}
}